import { MsalGuardConfiguration, MsalInterceptorConfiguration } from '@azure/msal-angular';
import { InteractionType, IPublicClientApplication, PublicClientApplication } from '@azure/msal-browser';

/* eslint-disable no-restricted-globals -- MSAL runs in browser only; factory has no DI context for Window token */

const MSAL_AUTHORITY = 'https://login.microsoftonline.com/ed4961a7-e434-4dab-bd13-eeb8ac6ce35c';
const MSAL_CLIENT_ID = 'fd329a45-0452-421e-b9f5-75390565e7b9';
const DEFAULT_ORIGIN = 'http://localhost:4200';
const MSAL_SCOPES = ['openid', 'offline_access', 'https://graph.microsoft.com/mail.read'];

/**
 * Returns the redirect URI for MSAL (origin + /callback). Uses location.origin in browser, fallback otherwise.
 * @returns {string} Redirect URI
 */
function getRedirectUri(): string {
  if (typeof window !== 'undefined' && window.location?.origin) {
    return `${window.location.origin}/callback`;
  }

  return `${DEFAULT_ORIGIN}/callback`;
}

/**
 * Returns the state for MSAL (origin + /). Uses location.origin in browser, fallback otherwise.
 * @returns {string} State URI
 */
function getState(): string {
  if (typeof window !== 'undefined' && window.location?.origin) {
    return `${window.location.origin}/`;
  }

  return `${DEFAULT_ORIGIN}/`;
}

/**
 * Creates the MSAL public client application instance.
 * @returns {IPublicClientApplication} MSAL instance
 */
function msalConfigFactory(): IPublicClientApplication {
  return new PublicClientApplication({
    auth: {
      authority: MSAL_AUTHORITY,
      clientId: MSAL_CLIENT_ID,
      redirectUri: getRedirectUri(),
      // Prevent MSAL from auto-navigating back to origin URI after token exchange.
      // Without this, MSAL navigates to /login before handleRedirectPromise resolves,
      // destroying the Callback component before our .then() callback fires.
      navigateToLoginRequestUrl: false,
    },
  });
}

/**
 * Creates the MSAL guard configuration.
 * @returns {MsalGuardConfiguration} Guard config
 */
function msalGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    authRequest: {
      scopes: MSAL_SCOPES,
      state: getState(),
    },
  };
}

/**
 * Creates the MSAL interceptor configuration.
 * @returns {MsalInterceptorConfiguration} Interceptor config
 */
function msalInterceptorConfigFactory(): MsalInterceptorConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap: new Map([['https://graph.microsoft.com/v1.0/', ['https://graph.microsoft.com/mail.read']]]),
  };
}

export { MSAL_SCOPES, msalConfigFactory, msalGuardConfigFactory, msalInterceptorConfigFactory };
